import { Box, Button, styled } from '@mui/material';

import { flexMixin } from 'utils/flexMixin';

export const DeleteModalContent = styled(Box)({
	...flexMixin({ direction: 'column' }),
	width: '100%',
	padding: '48px 64px',
});

export const ConfirmButton = styled(Button)({
	height: '44px',
	width: '215px',
	borderRadius: '8px',
	textTransform: 'none',
	fontSize: '16px',
	fontWeight: '700',
	marginTop: '24px',
});

export const CancelButton = styled(Button)({
	height: '44px',
	width: '215px',
	borderRadius: '8px',
	textTransform: 'none',
	fontSize: '16px',
	fontWeight: '700',
	marginTop: '24px',
});
